import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from './util/Auth';


export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
	// Default to using the first account if no account is active on page load
	if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
		// Account selection logic is app dependent. Adjust as needed for different use cases.
		msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
	}

	// Optional - This will update account state if a user signs in from another tab or window
	msalInstance.enableAccountStorageEvents();

	msalInstance.addEventCallback((event: EventMessage) => {
		if (event && event.eventType === EventType.LOGIN_SUCCESS && event.payload && (event.payload as AuthenticationResult).account) {
			const account = (event.payload as AuthenticationResult).account;
			msalInstance.setActiveAccount(account);
		}
	});

	ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
		<App pca={msalInstance} />
	);
});

